import environment from '../constants/environment';
import fetch from 'node-fetch'; // TODO: Remove when updating to Node 18+

const removeRedundantKeys = filters => {
  return Object.fromEntries(
    Object.entries(filters).filter(([_, value]) => value != 'all')
  );
};

export default {
  performSearch: (filters, page = 1) => dispatch => {
    const endpoint = `${environment.apiURL}/v2/vendors?showFacets=true`;
    const searchFilters = removeRedundantKeys(filters);
    console.log(`🔍 Performing search on endpoint: ${endpoint}`);
    console.log(`🔍 Searching with filters: `, Object.keys(searchFilters));
    return new Promise(resolve => {
      dispatch({
        type: 'SEARCH_INITIATED',
      });
      fetch(
        `${endpoint}&${new URLSearchParams({
          ...searchFilters,
          limit: 50,
        })}`,
        {
          method: 'GET',
        }
      )
        .then(res => res.json())
        .then(res => {
          const { data = [], facets, page } = res;

          dispatch({
            type: 'RECEIVE_SEARCH_RESULTS',
            hits: data,
            facets: { area_level_2: facets },
          });

          resolve(data);
        });
    });
  },
};
